import map from "lodash/map"


export class GetFloorDetailResponse {
    constructor(responseJSON) {
        this.responseJSON = responseJSON;
    }

    getSectionName() {
        return this.responseJSON["sectionNumber"];
    }

    getHousingName() {
        return this.responseJSON["housingName"];
    }

    getFloorDPF() {
        return this.responseJSON["pdf"];
    }

    getFloorsTotal() {
        let floors = this.responseJSON["floors"],
            floorsCount = floors.length,
            florNumber = floors[floorsCount - 1].number;

        return florNumber;
    }

    getElevators() {
        return this.responseJSON["sectionElevators"];
    }

    getFloorId() {
        return this.responseJSON["floorId"];
    }

    getFloorNumber() {
        return this.responseJSON["floorNumber"];
    }

    getFloorPlan() {
        return this.responseJSON["floorPlan"];
    }

    getFinishedStatus() {
        let finishedStatus = this.responseJSON["sectionFinished"];
        if (!finishedStatus) {
            return '';
        } else {
            return finishedStatus;
        }
    }

    getSectionMinischeme() {
        let minischeme = this.responseJSON["sectionMinischeme"];

        if (minischeme === null || minischeme === '') {
            return null;
        } else {
            return minischeme
        }

    }

    getFloorViewBox() {
        return this.responseJSON["floorViewBox"];
    }

    getFloorNext() {
        let next = this.responseJSON["floorNav"]["nextId"],
            floors = this.responseJSON["floors"];

        if (next === null) {
            next = floors[0].id;
        }

        return next;
    }

    getFloorPrev() {
        let prev = this.responseJSON["floorNav"]["prevId"],
            floors = this.responseJSON["floors"],
            floorsCount = floors.length;

        if (prev === null) {
            prev = floors[floorsCount - 1].id;
        }

        return prev;
    }


    getFloorSimilar(sectionCurrent) {
        let similarFloors = this.responseJSON["similarFloors"],
            currentFloor = null;

        let i = 0;
        while (i < similarFloors.length) {
            if (similarFloors[i].sectionId == sectionCurrent) {
                currentFloor = similarFloors[i].floorId;
                if (!currentFloor) {
                    currentFloor = null;
                }
                break
            }
            i++;
        }
        return currentFloor;
    }

    /**
     * @returns {FloorsList[]}
     */
    getFloorsList() {
        return map(this.responseJSON["floors"], (floorsJSON) => {
            return new FloorsList(floorsJSON);
        });
    }

    /**
     * @returns {FloorFlats[]}
     */
    getFloorsFlats() {
        return map(this.responseJSON["apartments"], (flatsJSON) => {
            return new FloorFlats(flatsJSON);
        });
    }

    getStreetUpName() {
         return this.responseJSON["streetUp"];
    }

    getStreetDownName() {
         return this.responseJSON["streetDown"];
    }

    getStreetLeftName() {
         return this.responseJSON["streetLeft"];
    }

    getStreetRightName() {
         return this.responseJSON["streetRight"];
    }

    getCurrentApartment() {
        return this.responseJSON["currentApartment"];
    }

    getEmptyFloor() {
        let flats = this.responseJSON["apartments"],
            flatsCount = flats.length,
            empty = true;

        for (let i = 0; i < flatsCount; i++) {
            if (flats[i].access) {
                empty = false;
                break;
            }
        }

        return empty;
    }


    /**
     ***********************
     *** SECTION INFORMATION
     ***********************
     **/
    getSectionNumber() {
        return this.responseJSON["sectionNumber"];
    }

    getHousingId() {
        return this.responseJSON["housingId"];
    }

    getHousingCode() {
        return this.responseJSON["housingCode"];
    }

    getSectionId() {
        return this.responseJSON["sectionId"];
    }

    getSectionPrev() {
        let prev = this.responseJSON["sectionNav"]["prevId"],
            sections = this.responseJSON["sections"],
            sectionsCount = sections.length;

        if (prev === null) {
            prev = sections[sectionsCount - 1].id;
        }

        return prev;
    }

    getSectionNext() {
        let next = this.responseJSON["sectionNav"]["nextId"],
            sections = this.responseJSON["sections"];

        if (next === null) {
            next = sections[0].id;
        }

        return next;
    }

    getSectionAzimuth() {
        let azimuth = this.responseJSON["housingAzimuth"];
        if (parseInt(azimuth) < 0 || parseInt(azimuth) > 360 || azimuth == null || isNaN(azimuth))
            azimuth = 0;
        return parseInt(azimuth);
    }

    getSectionImage() {
        return this.responseJSON["housingImage"];
    }

    getHousingViewBox() {
        return this.responseJSON["housingViewBox"];
    }

    /**
     * @returns {Sections[]}
     */
    getSections() {
        return map(this.responseJSON["sections"], (sectionsJSON) => {
            return new Sections(sectionsJSON);
        });
    }

    /**
     * @returns {SectionFloor[]}
     */
    getSectionsCoordinates() {
        return map(this.responseJSON["sections"], (sectionsJSON) => {
            return new HousingSection(sectionsJSON);
        });
    }

    getConsultation() {
        return this.responseJSON['getConsultation'];
    }
}

class HousingSection {
    constructor(sectionsJSON) {
        this.sectionsJSON = sectionsJSON;
    }

    getId() {
        return this.sectionsJSON["id"];
    }

    getNumber() {
        return this.sectionsJSON["number"];
    }

    getCoordinates() {
        return this.sectionsJSON["coordinates"];
    }

}


class FloorFlats {
    constructor(flatsJSON) {
        this.flatsJSON = flatsJSON;
    }

    getId() {
        return this.flatsJSON["id"];
    }

    getAccess() {
        return this.flatsJSON["access"];
    }

    getCoordinates() {
        return this.flatsJSON["coordinates"];
    }

    getRooms() {
        return this.flatsJSON["roms"];
    }

    getSpace() {
        return this.flatsJSON["space"];
    }

    getFinishing() {
        let finishing = this.flatsJSON["finishing"],
            repair = 'нет';

        if (finishing) {
            repair = 'есть';
        }
        return repair;
    }

    getPrice() {
        return this.flatsJSON["price"];
    }

}


class Sections {
    constructor(sectionsJSON) {
        this.sectionsJSON = sectionsJSON;
    }

    getId() {
        return this.sectionsJSON["id"];
    }

    getNumber() {
        return this.sectionsJSON["number"];
    }

    getCoordinates() {
        return this.sectionsJSON["coordinates"];
    }

}


class FloorsList {
    constructor(floorsJSON) {
        this.floorsJSON = floorsJSON;
    }

    getId() {
        return this.floorsJSON["id"];
    }

    getNumber() {
        return this.floorsJSON["number"];
    }

}


// WEBPACK FOOTER //
// ./js/api/GetFloorResponse.js